import ssm from 'simplestatemanager';

export default new class {

    constructor() {
        this.ssm = ssm;
        this.callbacks = {
            'sm': {
                'enter': [],
                'leave': [],
                'resize': [],
                'firstRun': []
            },

            'md': {
                'enter': [],
                'leave': [],
                'resize': [],
                'firstRun': []
            },

            'lg': {
                'enter': [],
                'leave': [],
                'resize': [],
                'firstRun': []
            },

            'xl': {
                'enter': [],
                'leave': [],
                'resize': [],
                'firstRun': []
            },

            'mobile': {
                'enter': [],
                'leave': [],
                'resize': [],
                'firstRun': []
            },

            'desktop': {
                'enter': [],
                'leave': [],
                'resize': [],
                'firstRun': []
            },
        };
    }


    run(){
        this.ssm.addState({
            id: 'sm',
            query: '(max-width: 767px)',
            onEnter: this.onEnter('sm'),
            onLeave: this.onLeave('sm'),
            onResize: this.onResize('sm'),
            onFirstRun: this.onFirstRun('sm')
        });

        this.ssm.addState({
            id: 'md',
            query: '(min-width: 768px) and (max-width: 991px)',
            onEnter: this.onEnter('md'),
            onLeave: this.onLeave('md'),
            onResize: this.onResize('md'),
            onFirstRun: this.onFirstRun('md')
        });

        this.ssm.addState({
            id: 'lg',
            query: '(min-width: 992px) and (max-width: 1199px)',
            onEnter: this.onEnter('lg'),
            onLeave: this.onLeave('lg'),
            onResize: this.onResize('lg'),
            onFirstRun: this.onFirstRun('lg')
        });

        this.ssm.addState({
            id: 'xl',
            query: '(min-width: 1200px)',
            onEnter: this.onEnter('xl'),
            onLeave: this.onLeave('xl'),
            onResize: this.onResize('xl'),
            onFirstRun: this.onFirstRun('xl')
        });

        this.ssm.addState({
            id: 'mobile',
            query: '(max-width: 991px)',
            onEnter: this.onEnter('mobile'),
            onLeave: this.onLeave('mobile'),
            onResize: this.onResize('mobile'),
            onFirstRun: this.onFirstRun('mobile')
        });

        this.ssm.addState({
            id: 'desktop',
            query: '(min-width: 992px)',
            onEnter: this.onEnter('desktop'),
            onLeave: this.onLeave('desktop'),
            onResize: this.onResize('desktop'),
            onFirstRun: this.onFirstRun('desktop')
        });
    }

    addOnEnter(stateId, callback) {
        if(
            typeof this.callbacks[stateId] !== 'undefined'
            && typeof this.callbacks[stateId].enter !== 'undefined'
            && typeof callback === 'function'
        ) {
            this.callbacks[stateId].enter.push(callback);
        }
    };

    addOnLeave(stateId, callback) {
        if(
            typeof this.callbacks[stateId] !== 'undefined'
            && typeof this.callbacks[stateId].leave !== 'undefined'
            && typeof callback === 'function'
        ) {
            this.callbacks[stateId].leave.push(callback);
        }
    };

    addOnResize(stateId, callback) {
        if(
            typeof this.callbacks[stateId] !== 'undefined'
            && typeof this.callbacks[stateId].resize !== 'undefined'
            && typeof callback === 'function'
        ) {
            this.callbacks[stateId].resize.push(callback);
        }
    };

    addOnFirstRun(stateId, callback) {
        if(
            typeof this.callbacks[stateId] !== 'undefined'
            && typeof this.callbacks[stateId].firstRun !== 'undefined'
            && typeof callback === 'function'
        ) {
            this.callbacks[stateId].firstRun.push(callback);
        }
    };

    onEnter(stateId) {
        let self = this;
        return function() {
            for(let i = 0; i < self.callbacks[stateId].enter.length; i++) {
                self.callbacks[stateId].enter[i].apply();
            }
        };
    };

    onLeave(stateId) {
        let self = this;
        return function() {
            for(let i = 0; i < self.callbacks[stateId].leave.length; i++) {
                self.callbacks[stateId].leave[i].call();
            }
        };
    };

    onResize(stateId) {
        let self = this;
        return function() {
            for(let i = 0; i < self.callbacks[stateId].resize.length; i++) {
                self.callbacks[stateId].resize[i].call();
            }
        };
    };

    onFirstRun(stateId) {
        let self = this;
        return function() {
            for(let i = 0; i < self.callbacks[stateId].firstRun.length; i++) {
                self.callbacks[stateId].firstRun[i].call();
            }
        };
    };
}
